import React, { Component } from 'react'; import { Link } from
'react-router-dom';

import config from './../config';

class AppMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			menuContent: null,
			currentPage: -1
		}
	}

	componentDidUpdate() {
		if (this.props.menuOpen && !this.state.menuContent) {
			this.fetchMenuContent();
		}
	}

	fetchMenuContent() {
		fetch(config.pageUrl+'menu_'+window.currentLang+'.json')
			.then(res => res.json())
			.then(json => this.setState({menuContent: json.results}));
	}

	render() {
		// window.currentLang == 'is'
		return (
			<div className={'menu-wrapper'+(this.state.currentPage > -1 ? ' main-visible' : '')} ref="menuContent">
				<div className="menu-content links">
					<p>
						{
							[
								{
									lang: 'is',
									name: 'Íslenska'
								},
								{
									lang: 'en',
									name: 'English'
								}
							].map((lang, index) => {
								return <span key={index}>{
									index > 0 &&
									<React.Fragment> | </React.Fragment>
								}<a key={lang.lang} href="#" onClick={event => {
									event.preventDefault();

									window.Lang.setCurrentLang(lang.lang);

									this.fetchMenuContent();
								}}><strong>{lang.name}</strong></a></span>
							})
						}
					</p>
					<div className="menu-links">
						{
							this.state.menuContent &&
							this.state.menuContent.map((item, index) => {
								return <a className="menu-link" key={index} onClick={() => this.setState({
									currentPage: index
								})}>{item.titill}</a>
							})
						}
					</div>
				</div>
				<div className="menu-content main">
					<a className="menu-link" onClick={() => this.setState({
						currentPage: -1
					})}>&lt; {window.l('menu_back')}</a>
					{
						this.state.currentPage > -1 && this.state.menuContent &&
						<React.Fragment>
							<h3>{this.state.menuContent[this.state.currentPage].titill}</h3>
							<div dangerouslySetInnerHTML={{__html: this.state.menuContent[this.state.currentPage].efni}} />
						</React.Fragment>
					}
				</div>
			</div>
		);
	}
}

export default AppMenu;



// WEBPACK FOOTER //
// ./src/components/AppMenu.js